<template>
  <div>
    <Head title="Create Sector Target"/>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/sector-targets">Sector Targets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>
        Create
      </b-breadcrumb-item>
    </b-breadcrumb>
    <card-component title="Create Sector Target">
        <div class="my-2">
          <b-autocomplete
            :data="marketList"
            placeholder="Type a Market Name..."
            field="title"
            @typing="updateMarketList"
            @select="selectMarket">
            <template #default="props">
              {{ props.option.label }}
            </template>
          </b-autocomplete>
        </div>
        <b-table striped bordered :data="marketData">
          <b-table-column label="Market" v-slot="{ row }">
            {{ row.data }}
          </b-table-column>
          <b-table-column numeric v-slot="{ row }">
  <!--          <Link class="button is-small is-danger" @click="removeVertical(row)">-->
  <!--            Remove-->
  <!--          </Link>-->
  <!--          <Link class="button is-small is-info" :href="`/sector-targets/${row.sector_target.id}`">-->
  <!--            View-->
  <!--          </Link>-->
          </b-table-column>
        </b-table>
        <div class="my-2">
          <b-autocomplete
            :data="verticalList"
            placeholder="Type a Vertical Name..."
            field="title"
            @typing="updateVerticalList"
            @select="selectVertical">
            <template #default="props">
              {{ props.option.name }}
            </template>
          </b-autocomplete>
        </div>
        <b-table striped bordered :data="verticalData">
          <b-table-column label="Vertical" v-slot="{ row }">
            {{ row.data }}
          </b-table-column>
          <b-table-column numeric v-slot="{ row }">
  <!--          <Link class="button is-small is-info" :href="`/verticals/${row.id}`">-->
  <!--            View-->
  <!--          </Link>-->
          </b-table-column>
        </b-table>
      <div class="is-flex is-fullwidth is-justify-content-flex-end">
        <b-button
                  v-if="!existingSectorTarget"
                  :disabled="existingSectorTarget"
                  type="is-info"
                  @click="store">
          Create Sector Target
        </b-button>
        <span>
          <p class="is-warning" v-if="existingSectorTarget">
            Sector Target already exists.
          </p>
          <Link v-if="existingSectorTarget" @click="$parent.close()" class="button is-justify-content-flex-end is-info" :href="`/sector-targets/${existingSectorTarget.id}`">
            View
          </Link>
        </span>
      </div>
    </card-component>
  </div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios';
import CardComponent from "@/Shared/CardComponent";

export default {
  components: {
    CardComponent,
    LoadingButton,
  },
  props: {
  },
  data() {
    return {
      currentVertical: null,
      currentMarket: null,
      verticalList: [],
      marketList: [],
      existingSectorTarget: null
    }
  },
  computed: {
    marketData() {
      if (!this.currentMarket) {
        return []
      }
      return [
        {title: 'Market', data: this.currentMarket.label, id: this.currentMarket.id},
      ]
    },
    verticalData() {
      if (!this.currentVertical) {
        return []
      }
      return [
        {title: 'Vertical', data: this.currentVertical.name, id: this.currentVertical.id},
      ]
    }
  },
  methods: {
    async store() {
      await axios.post(`/markets/${this.currentMarket.id}/attach-vertical/${this.currentVertical.id}`);
      await this.fetchSectorTarget();
      this.$parent.close();
      this.$inertia.get(`/sector-targets/${this.existingSectorTarget.id}`)
    },
    async updateVerticalList(query) {
      let {data} = await axios.get('/verticals/search?search=' + query);
      this.verticalList = data.verticals;
    },
    async updateMarketList(query) {
      let {data} = await axios.get('/markets/search?search=' + query);
      this.marketList = data.markets;
    },
    selectVertical(vertical) {
      this.currentVertical = vertical;
      this.fetchSectorTarget();
      // await axios.post(`/markets/${this.market.id}/attach-vertical/${vertical.id}`);
      // this.$inertia.get(`/markets/${this.market.id}/edit`)
    },
    selectMarket(market) {
      this.currentMarket = market;
      this.fetchSectorTarget();
      // await axios.post(`/markets/${this.market.id}/attach-vertical/${vertical.id}`);
      // this.$inertia.get(`/markets/${this.market.id}/edit`)
    },
    async fetchSectorTarget(){
      if(!(this.currentMarket && this.currentVertical)){
        return
      }
      let {data} = await axios.get(`/sector-targets/search?market_id=${this.currentMarket.id}&vertical_id=${this.currentVertical.id}`);
      this.existingSectorTarget = data.sectorTarget;
    }
    // async removeVertical(vertical) {
    //   await axios.delete(`/markets/${this.market.id}/detach-vertical/${vertical.id}`);
    //   this.$inertia.get(`/markets/${this.market.id}/edit`)
    // }
  },
}
</script>
